import React from 'react';

export default function LoanLoadStatus({ loading, error, refresh }) {
  return <div style={{ margin: '12px 0' }}>
    {loading && <span role="status">Refreshing loans… </span>}
    {error && <span role="alert">{error} </span>}
    <button type="button" onClick={refresh} disabled={loading}>Refresh loans</button>
  </div>;
}
